module.exports = __webpack_public_path__ + "static/media/revised.7a89fb9d.svg";